module.exports = __webpack_public_path__ + "static/media/40.c53a8ee5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/40.jpg
// module id = 573
// module chunks = 0